import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import PlantConstants from "../Constants/PlantConstants";

let newplantAddResult = [];
let updateplantResult = [];
let addPlantWebAdminResult = [];
let deletePlant = [];
class PlantStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getNewplantAddResult() {
    return newplantAddResult;
  }

  setNewplantAddResult(result) {
    newplantAddResult = result;
  }

  getUpdatePlantResult() {
    return updateplantResult;
  }

  setUpdatePlantResult(result) {
    updateplantResult = result;
  }

  getAddPlantWebAdminResult() {
    return addPlantWebAdminResult;
  }

  setAddPlantWebAdminResult(res) {
    addPlantWebAdminResult = res;
  }
  getDeletePlant() {
    return deletePlant;
  }

  setDeletePlant(res) {
    deletePlant = res;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case PlantConstants.ADD_NEW_PLANT_SUCCESS:
        this.setNewplantAddResult(action.result);
        break;
      case PlantConstants.ADD_NEW_PLANT_FAILURE:
        this.setNewplantAddResult(action.result);
        break;
      case PlantConstants.UPDATE_PLANT_SUCCESS:
        this.setUpdatePlantResult(action.result);
        break;
      case PlantConstants.UPDATE_PLANT_FAILURE:
        this.setUpdatePlantResult(action.result);
        break;
      case PlantConstants.ADD_PLANT_WEBADMIN_SUCCESS:
        this.setAddPlantWebAdminResult(action.result);
        break;
      case PlantConstants.ADD_PLANT_WEBADMIN_FAILURE:
        this.setAddPlantWebAdminResult(action.result);
        break;
      case PlantConstants.DELETE_PLANT_SUCCESS:
        this.setDeletePlant(action.result);
        break;
      case PlantConstants.DELETE_PLANT_FAILURE:
        this.setDeletePlant(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const plantStore = new PlantStore();
dispatcher.register(plantStore.handleCallback.bind(plantStore));
export default plantStore;
